import { Search } from './search';

export class AdminSearchDTO extends Search {
    username: string = '';

    name: string = '';
}

export class AdminDTO {
    username: string = ''; // 관리자 ID

    name: string = ''; // 관리자 이름

    password: string = ''; // 관리자 비밀번호

    email: string = ''; // 관리자 이메일

    phone: string = ''; // 관리자 전화번호

    adminId: string = ''; // 관리자 생성자 ID

    regdate: Date; // 관리자 등록일

    updatedId: string = ''; // 관리자 수정자 ID

    active: number = 1; // 관리자 활성화 여부

    roles: Array<string> = new Array<string>(); // 관리자 권한 목록

    menus: string[] = []; // 신규 추가: 메뉴 권한 (path 배열)
}

export class RoleDTO {
    role: String = '';

    name: String = '';

    master: string = '';

    _checked: boolean = false;

    public static roles(): Array<any> {
        return [
            { key: 'master', name: '마스터', _checked: false },
            { key: 'admin', name: '관리자', _checked: false },
            { key: 'trip', name: '출장자', _checked: false },
            { key: 'normal', name: '일반', _checked: false },
        ];
    }
}

export interface MenuDTO {
    id: string;
    path: string;
    label: string;
    icon: string;
    description?: string; // 관리자 등록 화면에서 설명용
    badge?: (counts: any) => React.ReactNode;
    location?: 'sidebar' | 'navbar' | 'both'; // 메뉴 위치 추가
}

export const getMenus = (): MenuDTO[] => {
    return [
        {
            id: 'home',
            path: '/',
            label: '홈',
            icon: 'fas fa-home',
            description: '대시보드 홈 화면',
            location: 'sidebar'
        },
        {
            id: 'reception',
            path: '/reception',
            label: '접수 관리',
            icon: 'fas fa-clipboard-list',
            description: '고객 접수 관리',
            location: 'sidebar'
        },
        {
            id: 'today-reception',
            path: '/today-reception',
            label: 'TODAY접수',
            icon: 'fas fa-clipboard-list',
            description: '당일 접수 관리',
            location: 'sidebar'
        },
        {
            id: 'inbound',
            path: '/inbound',
            label: '입고 관리',
            icon: 'fas fa-boxes',
            description: '제품 입고 처리',
            location: 'sidebar',
            badge: (counts) => counts.inboundCnt
        },
        {
            id: 'repair',
            path: '/repair',
            label: '수리 관리',
            icon: 'fas fa-tools',
            description: '수리 현황 관리',
            location: 'sidebar',
            badge: (counts) => counts.repairCnt
        },
        {
            id: 'outbound',
            path: '/outbound',
            label: '출고 관리',
            icon: 'fas fa-truck',
            description: '제품 출고 처리',
            location: 'sidebar',
            badge: (counts) => counts.outboundCnt
        },
        {
            id: 'trip',
            path: '/trip',
            label: '출장 관리',
            icon: 'fas fa-route',
            description: '출장 일정 관리',
            location: 'sidebar',
            badge: (counts) => counts.tripCnt
        },
        {
            id: 'estimate',
            path: '/estimate',
            label: '견적 관리',
            icon: 'fas fa-file-invoice',
            description: '견적서 작성 및 관리',
            location: 'sidebar',
            badge: (counts) => counts.arrearsCnt
        },
        {
            id: 'exchange',
            path: '/exchange',
            label: '맞교환 관리',
            icon: 'fas fa-file-invoice',
            description: '제품 맞교환 처리',
            location: 'sidebar'
        },
        {
            id: 'stock',
            path: '/stock',
            label: '보일러 재고현황',
            icon: 'fas fa-warehouse',
            description: '재고 현황 조회',
            location: 'sidebar'
        },
        {
            id: 'as-analytics',
            path: '/as-analytics',
            label: 'AS현황 분석',
            icon: 'fas fa-chart-line',
            description: 'AS 데이터 분석',
            location: 'sidebar'
        },
        {
            id: 'as-calendar',
            path: '/as-calendar',
            label: '캘린더',
            icon: 'fas fa-calendar-alt',
            description: '일정 캘린더',
            location: 'sidebar'
        },
        {
            id: 'agent-stats',
            path: '/agent-stats',
            label: '출장자별 통계',
            icon: 'fas fa-user-chart',
            description: '출장자별 통계 분석',
            location: 'sidebar'
        },
        {
            id: 'repair-statistics',
            path: '/repair-statistics',
            label: 'AS 수익분석',
            icon: 'fas fa-chart-bar',
            description: 'AS 수익 분석 및 통계',
            location: 'sidebar'
        },
        // NavBar 메뉴 추가
        {
            id: 'admin',
            path: '/admin',
            label: '관리자 관리',
            icon: 'fas fa-user-shield',
            description: '관리자 계정 관리 (master 권한 필요)',
            location: 'navbar'
        },
        {
            id: 'product',
            path: '/product',
            label: '상품 관리',
            icon: 'fas fa-box-open',
            description: '상품 정보 관리',
            location: 'navbar'
        },
        {
            id: 'trip-fee',
            path: '/trip-fee',
            label: '출장비 관리',
            icon: 'fas fa-won-sign',
            description: '출장비 설정 관리',
            location: 'navbar'
        },
    ]
};

// 위치별 메뉴 필터링 헬퍼 함수
export const getMenusByLocation = (location: 'sidebar' | 'navbar' | 'both') => {
    if (location === 'both') {
        return getMenus();
    }
    return getMenus().filter(menu => menu.location === location);
};